import classNames from 'classnames'
import {extendTailwindMerge} from 'tailwind-merge'

type ClassNameValue = Parameters<typeof classNames>[number]

const mergeDesignSystemClasses = extendTailwindMerge({
  theme: {
    borderRadius: [
      'ds-xs',
      'ds-sm',
      'ds-md',
      'ds-lg',
      'ds-xl',
      'ds-2xl',
      'ds-pill',
    ],
  },
  classGroups: {
    'font-size': [
      {
        text: [
          'type-display',
          'type-h1',
          'type-h2',
          'type-h3',
          'type-h4',
          'type-title',
          'type-body',
          'type-sm',
          'type-xs',
          'type-2xs',
        ],
      },
    ],
    duration: [{duration: ['fast', 'base', 'slow']}],
    ease: [{ease: ['standard', 'dope-out']}],
    shadow: [
      {
        shadow: [
          'card',
          'raised',
          'modal',
          'glow-cyan',
          'glow-lilac',
          'glow-green',
          'ring-focus',
        ],
      },
    ],
  },
})

export function cn(...inputs: ClassNameValue[]): string {
  return mergeDesignSystemClasses(classNames(inputs))
}
